import { Box } from '@mui/material';

export default function NotAuthorized() {
  return (
    <Box sx={{ padding: '2rem' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          fontSize: '1.25rem',
          lineHeight: '1.75rem',
          fontWeight: '600',
        }}
      >
        You are not authorized to view this page.
      </Box>
    </Box>
  );
}
